import { AppClient } from "../submodules/rapdv/client/app/AppClient"
import { ClientPage } from "../submodules/rapdv/client/elements/PagesCtrl"
import { PageDocs } from "./pages/PageDocs"
import { PageEditPost } from "./pages/PageEditPost"
import { selectJsChoicesInit } from "./assets/app/js/choices.js"
import { datePickerInit } from "./assets/app/js/flatpickr.js"
import { DropzoneOrdered } from "./elements/dropzone-ordered/DropzoneOrdered"
import "./assets/app/js/flatpickr.js"
import "./styles/Styles.tsx"
import { PageLogin } from "./pages/PageLogin"

const onPageLoaded = () => {
  selectJsChoicesInit()
  datePickerInit()
  DropzoneOrdered.setupDropzones()
}

const app = new AppClient(onPageLoaded)

const pages: Array<ClientPage> = []
pages.push(new PageEditPost())
pages.push(new PageDocs())
pages.push(new PageLogin())

app.start(pages)
